import { BaseModel } from "sjs-base-model";
import MessaggioEsitoModel from "./MessaggioEsitoModel";

export default class EsitoRichiestaModel extends BaseModel {
    public readonly status: number = 0;
    public readonly messaggioEsito: MessaggioEsitoModel = new MessaggioEsitoModel({});

    constructor(data: Partial<EsitoRichiestaModel>) {
        super();

        this.update(data);
    }
}
